import { useSelector } from 'react-redux';
import {Control, Errors} from 'forms/rrf';
import {Col, Container, FormGroup, FormLabel, Row} from 'react-bootstrap';
import BsCheckbox from '../../../common/form/elements/bs-checkbox';

import './styles.css';

// A push goes to the associated user's handset, so it cannot be sent to Custom To recipients.
// The checkbox is only disabled for them - its value is kept, so switching the radio back
// restores it. createRequestData sends push: false for Custom To.
//
// Staging and next are built with REACT_APP_PUSH_NOTIFICATIONS=false (frontend/build.sh), and the
// backend never sends pushes there, so a one-line notice replaces the editor. Read at render
// time rather than at import so the tests can switch it.
const pushNotificationsEnabled = () => process.env.REACT_APP_PUSH_NOTIFICATIONS !== 'false';

const PushMessage = () => {
  // The Recipient radio stores its value as a string.
  const customRecipients = useSelector(state => state.deep.admin_notification_edit.to_associated_user) !== 'true';

  if (!pushNotificationsEnabled()) {
    return (
      <Container fluid className="editor">
        <p>Push notification is disabled on staging.</p>
      </Container>
    );
  }

  return (
    <Container fluid className="editor">
      <Row>
        <Col md={12}>
          <FormGroup>
            <Control.checkbox
              component={BsCheckbox}
              disabled={customRecipients}
              model='.push'
            >
              Push Notification
            </Control.checkbox>
          </FormGroup>
          <FormGroup controlId="push-title">
            <FormLabel>
              Title*
            </FormLabel>
            <Control.text
              className="form-control"
              model=".push_title"
            />

            <Errors
              className="errors"
              model=".push_title"
              show={{
                touched: true,
                focus: false
              }}
            />
          </FormGroup>
          <FormGroup controlId="push-body">
            <FormLabel>
              Body*
            </FormLabel>
            <Control.textarea
              className="form-control"
              model=".push_body"
              rows="2"
            />

            <Errors
              className="errors"
              model=".push_body"
              show={{
                touched: true,
                focus: false
              }}
            />
          </FormGroup>
        </Col>
      </Row>
    </Container>
  );
};

export default PushMessage;
